import { DEFAULT_PAGE_SIZE } from '@/const';
import { Pagination } from '@/typings/common';
import errCode from '@/utils/request/errCode';
import { observable, action } from 'mobx';
import { getEnumPackage, GetEnumPackageReqParam } from '../server/enumService';
import { EnumDrawerMode, EnumItem, EnumPackage } from '../type/enumType';

const BLANK_ENUM_ITEM: EnumItem = {
  key: '',
  value: '',
  description: '',
};

const BLANK_ENUM_PACKAGE_ITEM: EnumPackage = {
  teamId: '',
  id: '',
  name: '',
  valueFormat: '',
  enums: [BLANK_ENUM_ITEM],
  interfaces: [],
};

class EnumStore {
  @observable selectedEnumPackage: EnumPackage = BLANK_ENUM_PACKAGE_ITEM;

  @observable packageList: EnumPackage[] = [];

  @observable filterKeyword = '';

  @observable currentDrawerMode: EnumDrawerMode = EnumDrawerMode.None;

  /**
   * 枚举包是否过期，默认过期。用于加载枚举包列表
   */
  @observable listOutdate = true;

  // @observable teamId = useUrlQuery()?.team_id || '';

  @observable pageInfo: Pagination = {
    page: 1,
    totalNumber: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  };

  @action
  resetPageNumber() {
    this.pageInfo.page = 1;
  }

  @action
  resetSelectedEnumPackage() {
    if (this.currentDrawerMode === EnumDrawerMode.None) {
      this.selectedEnumPackage = BLANK_ENUM_PACKAGE_ITEM;
    }
  }

  @action
  async fetchEnumPackageList(req?: GetEnumPackageReqParam, checkExpired = false) {
    if (!checkExpired || (checkExpired && this.listOutdate)) {
      try {
        const { data, code } = await getEnumPackage({
          page: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize,
          keyword: this.filterKeyword,
          ...req,
        });
        if (code === errCode.SUCCESS) {
          this.packageList = data.list || [];
          this.pageInfo = { ...this.pageInfo, ...data.pageInfo };
          this.listOutdate = false;
        } else {
          // exception catch
        }
      } catch (e) {
        // error boundary
      }
    }
  }

  @action
  updateInterfaceStatus(updateInterfaceIdList: string[] = []) {
    const { interfaces = [] } = this.selectedEnumPackage;
    const updatedList = interfaces.map((api) => (updateInterfaceIdList.indexOf(api.interfaceId) >= 0 ? ({
      ...api,
      expired: false,
    }) : { ...api }));
    this.selectedEnumPackage.interfaces = updatedList;
  }
}

export default {
  name: 'enumStore',
  Store: EnumStore,
};
